import React, { ReactElement } from 'react'
import JobList from '@components/modules/content/M010-JobList'
import PressList from '@components/modules/content/M016-PressList'
import NewsList from '@components/modules/content/M012-NewsList'
import JobFixedApply from './types/jobfixedapply'

export type FixedContentProps = DBN.IReactDefaultProps & {
  pageContext?: DBN.PageHelpers.PageContext
  theme?: string
  anchor?: string
  element?: string
}

export default function FixedContent({
  pageContext,
  theme,
  anchor,
  element,
  ...props
}: FixedContentProps): ReactElement {
  switch (element) {
    case 'joblist':
      return (
        <JobList
          pageContext={pageContext}
          theme={theme}
          anchor={anchor}
          {...props}
        />
      )
    case 'newslist':
      return (
        <NewsList
          pageContext={pageContext}
          theme={theme}
          anchor={anchor}
          {...props}
        />
      )
    case 'presslist':
      return (
        <PressList
          pageContext={pageContext}
          theme={theme}
          anchor={anchor}
          {...props}
        />
      )
    case 'jobfixedapply':
      return <JobFixedApply theme={theme} />
    default:
      return <></>
  }
}
